import Chart from '../Chart'
import Search from '../Search'
import { sortByKey } from '../utility'

export default {
    components: {
        Chart,
        Search,
    },
    props: {
        searchHeaderElement: String,
        chartHeaderElement: String,
        chartFooterElement: String,
    },
    data: () => ({
        district: '',
        districtData: {},
        error: false,
    }),
    computed: {
        searchHeader() {
            return { template: this.searchHeaderElement }
        },
        chartHeader() {
            return { template: this.chartHeaderElement }
        },
        chartFooter() {
            return { template: this.chartFooterElement }
        },
    },
    methods: {
        async selectDistrict(value) {
            this.district = value
            this.error = false

            if (value) {
                try {
                    this.districtData = {
                        ...this.districtData,
                        ...(await this.loadDistrictData(this.district)),
                    }

                    this.dispatchEvent('kpc:select', value)
                } catch (e) {
                    this.error = true
                    this.dispatchEvent('kpc:error')
                }
            } else {
                this.dispatchEvent('kpc:select', value)
            }
        },
        dispatchEvent(name, data = {}) {
            this.$refs.root.dispatchEvent(new CustomEvent(name, {
                bubbles: true,
                detail: data,
            }))
        },
        async loadDistrictData(key) {
            const data = (await import(`../data/${key}.json`)).default
            data.years.sort(sortByKey('year'))
            return data
        },
    },
}
